export const createApprovalStatusString = (
  approved?: boolean,
): string | null =>
  typeof approved === "boolean"
    ? approved
      ? "Approved"
      : "Not approved"
    : null;
